type MailRecipient = string | string[] | undefined;

export type OpenMailClientOptions = {
  to?: MailRecipient;
  cc?: MailRecipient;
  bcc?: MailRecipient;
  subject?: string;
  body?: string;
};

const normalizeRecipients = (value?: MailRecipient): string | undefined => {
  if (!value) return undefined;
  const list = (Array.isArray(value) ? value : [value])
    .map((item) => item.trim())
    .filter(Boolean);
  return list.length ? list.join(',') : undefined;
};

export const buildMailtoUrl = (options: OpenMailClientOptions): string => {
  const to = normalizeRecipients(options.to);
  const cc = normalizeRecipients(options.cc);
  const bcc = normalizeRecipients(options.bcc);
  const subject = options.subject?.trim();
  const body = options.body ?? '';

  const params = new URLSearchParams();
  if (cc) params.set('cc', cc);
  if (bcc) params.set('bcc', bcc);
  if (subject) params.set('subject', subject);
  if (body) params.set('body', body);

  const query = params.toString();
  return `mailto:${to ?? ''}${query ? `?${query}` : ''}`;
};

export const openMailClient = (options: OpenMailClientOptions): void => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  const mailtoUrl = buildMailtoUrl(options);

  const opened = window.open(mailtoUrl, '_self');
  if (!opened) {
    window.location.assign(mailtoUrl);
  }
};
